module.exports = __webpack_public_path__ + "media/images/static/interview/ArrowLeft-9da0a2ebb12512aed543474fd472c3cf.png";